/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BeneficiaryUpdateModel = {
    Id?: string | null;
    FirstName?: string;
    MiddleName?: string | null;
    LastName?: string;
    EntityName?: string;
    DateOfBirth?: string | null;
    Ssn?: string | null;
    SharePercentage?: number;
    BeneficiaryType?: BeneficiaryUpdateModel.BeneficiaryType;
    BeneficiaryLevel?: BeneficiaryUpdateModel.BeneficiaryLevel;
    Relationship?: string;
    Address?: string;
    City?: string;
    State?: string;
    ZipCode?: string;
    PhoneNumber?: string;
    Email?: string;
};
export namespace BeneficiaryUpdateModel {
    export enum BeneficiaryType {
        PERSON = 'Person',
        ENTITY = 'Entity',
    }
    export enum BeneficiaryLevel {
        PRIMARY = 'Primary',
        SECONDARY = 'Secondary',
    }
}

